import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { generateDownloadAnalyticsData } from 'helpers/generateDownloadAnalyticsData';

import { sendAnalyticEvent } from 'data/actions/analytics';
import { downloadDocument } from 'data/actions/documents';
import { toggleModal } from 'data/actions/modals';
import { convertDocumentDataSelector, uploadedFileSelector } from 'data/selectors/documents';

import { EModalTypes } from 'ts/enums/modal.types';

export const useDownloadDocumentWithSse = () => {
  const dispatch = useDispatch();
  const uploadedDocumentData = useSelector(uploadedFileSelector());
  const convertedDocumentData = useSelector(convertDocumentDataSelector());

  const handleTrustPilot = useCallback(
    (from: string) => {
      setTimeout(() => {
        dispatch(
          toggleModal({
            type: EModalTypes.TRUST_PILOT,
            visible: true,
            options: { from_event: from }
          })
        );
      }, 1500);
    },
    [dispatch]
  );

  const handleDownload = useCallback(
    (documentId: string) => {
      const onError = () => {
        dispatch(
          sendAnalyticEvent({
            event: 'file_download_status',
            data: generateDownloadAnalyticsData({ success: false, isManual: false })
          })
        );
      };

      const onSuccess = (res: any) => {
        dispatch(
          sendAnalyticEvent({
            event: 'file_download_status',
            data: generateDownloadAnalyticsData({
              success: true,
              isManual: false,
              fileData: res,
              inputFile: {
                size: uploadedDocumentData?.size || convertedDocumentData?.size
              }
            })
          })
        );
        dispatch(
          toggleModal({
            visible: false
          })
        );
        if (window.location.pathname === '/app/payment-success') {
          handleTrustPilot('auto_download_file');
        }
      };

      console.log('documentId in hook', documentId);
      dispatch(downloadDocument(documentId, onError, onSuccess));
    },
    [dispatch, uploadedDocumentData, convertedDocumentData, handleTrustPilot]
  );

  return { handleDownload };
};
